/**
 * <EditLesson />
 *
 * TODO: REFACTOR IT PLEASE
 *
 * This form allows user to choose a class, if chooseClass = true.
 * It returns an object which can be sent to API to add lesson.
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './EditLesson.scss';
import { Button, Form } from 'components/UI';
import ClassDetail from 'mediators/ClassDetail';
import Teacher from 'mediators/Teacher';
import Student from 'mediators/Student';
import Lesson from 'mediators/Lesson';
import { confirm } from 'util/confirm';
import { alert } from 'util/alert';
import moment from 'moment';
import sortBy from 'lodash/sortBy'

import deleteLesson from 'controllers/lesson/deleteLesson';
import updateLessonWithTime from 'controllers/lesson/updateLessonWithTime';
import addMultipleLessonWithTime from 'controllers/lesson/addMultipleLessonWithTime';
import locale from './locale';

const FREQUENCY = ['daily', 'weekly', 'monthly'];

export const UPDATE = 'UPDATE';
export const CREATE = 'CREATE';

class EditLesson extends React.Component {
  static propTypes = {
    conflictedSummary: PropTypes.object,
    classDetail: PropTypes.instanceOf(ClassDetail),
    lesson: PropTypes.instanceOf(Lesson),
    afterSubmit: PropTypes.func.isRequired,
  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.conflictDetailToSummary = this.conflictDetailToSummary.bind(this);
    this.deleteLesson = this.deleteLesson.bind(this);
    this.processFormData = this.processFormData.bind(this);
    this.getUiSchema = this.getUiSchema.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onError = this.onError.bind(this);
    this.getUiLogic = this.getUiLogic.bind(this);

    const {
      lesson,
      classDetail,
      startDate,
      studentList,
      teacherList,
    } = props;

    this.state = {
      lesson,
      formData: {},
      processedFormData: {},
      conflictedSummary: {
        conflicted_classroom_result: false,
        conflicted_teacher_summary: [],
        conflicted_student_summary: [],
      }
    }

    if (typeof lesson !== 'undefined') {
      this.state.mode = UPDATE;

      let teacher_id_list = []
      let student_id_list = []

      if(!lesson.teacherList && props.teacherList){
        teacherList.map((teacher) => {
          teacher_id_list.push({id: teacher.teacher_id, stName: teacher.teacher_name})
        })
      }
      if(!lesson.studentList && props.studentList){
        studentList.map((student) => {
          student_id_list.push({id: student.student_id, student_name: student.student_name})
        })
      }

      this.state.formData = {
        lesson_date: lesson.getDate(),
        time_range_str: lesson.getStartTime() + ':::' + lesson.getEndTime(),
        teacher_id_list_str: lesson.teacherList ? JSON.stringify(lesson.teacherList) : JSON.stringify(teacher_id_list),
        student_id_list_str: lesson.studentList ? JSON.stringify(lesson.studentList) : JSON.stringify(student_id_list),
        calendar_color: lesson.calendarColor,
        note: lesson.note,
      }

      console.log(lesson);

      if (lesson.classroomId) {
        this.state.formData.classroom_id_str = JSON.stringify([lesson.getClassroom()]);
      }

    } else if (typeof lesson === 'undefined' && props.classDetail) {
      const {
        classroomId,
        teacherList,
        studentList,
      } = props.classDetail;

      this.state.formData = {
        date_range_str: `${startDate}:::${startDate}`,
        time_range_str: moment('900','hmm').format('HH:mm') + ':::' + moment('930','hmm').format('HH:mm'),
        teacher_id_list_str: JSON.stringify(teacherList),
        student_id_list_str: JSON.stringify(studentList),
      }
      this.state.mode = CREATE;
    }

    this.processFormData(this.state.formData);
  }

  deleteLesson() {
    let {
      name,
    } = this.props.classDetail

    let {
      lesson,
    } = this.state;

    confirm(__("Delete {name}'s Lesson?", 'classdetail', { name }), __('Delete Lesson', 'classdetail'))
    .then(()=>{
      deleteLesson(lesson.id)
      .then((data)=>{
        // start_datetime is required to load schedule again
        this.props.afterSubmit({ ...data, start_datetime: lesson.startTime, })
      });
    });
  }

  onError(errors) {
    if (Array.isArray(errors) && errors.length > 0) {
      const { property } = errors[errors.length - 1];
      const name = property.replace('.', 'root_');
      const $errorLabel = document.querySelectorAll('[for="' + name + '"]');

      if ($errorLabel.length > 0) {
        this.lessonFormRef.scrollTop = this.lessonFormRef.scrollTop + $errorLabel[0].getBoundingClientRect().top - 120;
      }
    }
  }

  onSubmit({ formData }) {
    let cls = this.state.classDetail || this.props.classDetail;

    let { id } = cls;

    let {
      mode,
      lesson,
    } = this.state;

    this.setState({
      loading: true,
    });


    let convertedForm = this.processFormData(formData);

    if (mode === UPDATE) {
      let toSubmit = {
        start_datetime: convertedForm.start_datetime,
        end_datetime: convertedForm.end_datetime,
        teacher_id_list: convertedForm.teacher_id_list,
        student_id_list: convertedForm.student_id_list,
        classroom_id: convertedForm.classroom_id,
        new_name: lesson.name,
        calendar_color: convertedForm.calendar_color,
        note: convertedForm.note,
     }

      updateLessonWithTime(lesson.id, toSubmit)
      .then(({ data })=> {
        this.setState({
          loading: false,
        }, ()=>{
          if (data.conflicted_result === true) {
            this.handleConflicts(this.conflictDetailToSummary(data), formData);
          } else {
            this.props.afterSubmit(data);
          }
        });
      });
    } else if (mode === CREATE) {
      delete convertedForm.start_datetime;
      delete convertedForm.end_datetime;
      delete convertedForm.scheduling;

      if(convertedForm.start_date == 'undefined' || convertedForm.start_time == 'undefined' || convertedForm.end_date == 'undefined' || convertedForm.end_time == 'undefined'){
        return alert.warning(__('All Fields with * Must Be Filled', locale))
        .then(() => {this.setState({loading: false})})
      }

      addMultipleLessonWithTime(id, convertedForm)
      .then(({ data })=>{
        this.setState({
          loading: false,
        }, ()=>{
          if(data.new_lesson_id_list && data.new_lesson_id_list.length == 0){
            alert.warning(__('The start and end date of the scheduling did not cover the class date selected, so a total of 0 lessons were created', locale)).then(() => {})
          } else if (data.result === 'success') {
            this.props.afterSubmit(data);
          } else if (data.result === 'conflicted') {
            this.handleConflicts(this.conflictDetailToSummary(data.summary), formData)
          } else if (data.result == 'failure' && data.reason == 'start_time must be earlier than end_time'){
            alert.warning(__('End Time Must Be Later Than Start Time', locale)).then(() => {})

          }
        });
      })
      .catch((err)=>{
        console.error(err)
      });
    }
  }

  handleConflicts(conflictedSummary, formData) {
    alert.warning(__('There are conflicts while creating a lesson.', 'classdetail'));
    this.setState({
      conflictedSummary,
    }, ()=>{
      this.processFormData(formData);
    });
  }

  //
  // What is this?
  // When you update one lesson with updateLessonWithTime(), it only returns conflict details
  // and no summary while addMultipleLessonWithTime() does get a summary which is more useful
  // for us. So we will have to convert "detail" to "summary."
  //
  conflictDetailToSummary(detail) {
    const {student, teacher, classroom} = detail;
    return {
      conflicted_student_summary: (student.conflicted_student_list || []).map((s)=>s.student_id),
      conflicted_teacher_summary: (teacher.conflicted_teacher_list || []).map((s)=>s.teacher_id),
      conflicted_classroom_result: classroom.result,
    }
  }

  // onChange -> processFormData(do up the logic here) -> generateUISchema
  processFormData(formData) {
    let {
      lesson_date,
      date_range_str,
      scheduling,
      frequency,
      every,
      note,
      which_day_str,
      teacher_id_list_str,
      student_id_list_str,
      classroom_id_str,
      time_range_str,
      calendar_color,
    } = formData;

    let {mode} = this.state;

    //
    // We're going to convert formData into a format that we want
    //
    let start_date, end_date;
    if (date_range_str) {
      let dateRanges = date_range_str.split(':::');
      start_date = dateRanges[0];
      end_date = dateRanges[1];
    }

    if (formData.scheduling === false) {
      formData.date_range_str = start_date + ':::' + start_date;
      end_date = start_date;
    }

    let which_day;
    if (which_day_str) {
      which_day = sortBy(JSON.parse(which_day_str));
    }

    let start_time, end_time;
    if (time_range_str) {
      let timeRanges = time_range_str.split(':::');
      start_time = timeRanges[0];
      end_time = timeRanges[1];
    }

    let start_datetime, end_datetime;
    if (lesson_date && start_time && end_time) {
      start_datetime = lesson_date + ' ' + start_time;
      end_datetime = lesson_date + ' ' + end_time;
    }

    let classroom_id;
    if (classroom_id_str) {
      let classrooms = JSON.parse(classroom_id_str);
      if (classrooms.length > 0) {
        classroom_id = classrooms[0].id
      }
    }

    let teacher_id_list;
    if (teacher_id_list_str) {
      let teachers = JSON.parse(teacher_id_list_str);
      teacher_id_list = teachers.map((teacherRaw)=>{
        let teacher = new Teacher(teacherRaw);
        return teacher.id;
      });
    }

    let student_id_list;
    if (student_id_list_str) {
      let students = JSON.parse(student_id_list_str);
      student_id_list = students.map((studentRaw)=>{
        let student = new Student(studentRaw);
        return student.id;
      });
    }

    if (start_datetime) {
      start_datetime = moment(start_datetime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss');
    }

    if (end_datetime) {
      end_datetime = moment(end_datetime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss');
    }


    let converted = {
      scheduling,
      frequency,
      start_date,
      start_datetime,
      end_datetime,
      every,
      end_date,
      start_time,
      end_time,
      which_day,
      classroom_id,
      student_id_list,
      teacher_id_list,
      note,
      calendar_color,
    }

    let uiLogic = this.getUiLogic(converted);

    if (uiLogic.scheduling == true) {
      formData.scheduling = true;
    } else {
      delete formData.scheduling;
    }

    let filtered = this.getUiSchema(converted, uiLogic);

    this.setState({
      processedFormData: filtered,
      formData,
    });

    return filtered;

  }

  getUiLogic(converted) {
    const {
      scheduling,
      frequency,
      start_date,
      start_datetime,
      end_datetime,
      every,
      end_date,
      start_time,
      end_time,
      which_day,
      classroom_id,
      teacher_id_list,
      student_id_list,
      calendar_color,
    } = converted;

    let uiLogic = {
      scheduling: false,
    }

    // =========================================================
    // When start_date and end_date are the same,
    // we don't do scheduling
    if (start_date && end_date) {
      uiLogic.scheduling = start_date !== end_date;
      uiLogic.sameDate = start_date === end_date;
    }
    // =========================================================

    // =========================================================
    // When classType is 1on1, we disable selecting student
    const {
      classDetail,
    } = this.props;

    const classType = classDetail.getClassTypeStr();

    uiLogic.classType = classType;

    uiLogic.disableSelectingStudent = classType == '1on1';
    // =========================================================

    return uiLogic;
  }

  getUiSchema(processedFormData, uiLogic) {
    const {frequency, start_date, end_date, classroom_id} = processedFormData;

    const {mode, conflictedSummary} = this.state;
    const {classDetail} = this.props;
    const {type} = classDetail

    //
    // STEP 1. Decide which 'every' and which 'which_day' should be used
    //
    let every = {
      'ui:widget': 'dropdownselect',
      shown: false,
      inline: true,
    };

    let which_day_str = {
      shown: false,
    }

    // we will store all the required fields
    let required = [];

    if (mode === CREATE) {
      if (uiLogic.scheduling == true) {
        required = ['frequency'].concat(required);

        if (FREQUENCY[frequency] == 'daily') {
          required = ['every'].concat(required);
          every = {
            ...every,
            'ui:options': {
              selectOptions: [
                { value: 1, label: __('1 day', 'classdetail') },
                { value: 2, label: __('2 days', 'classdetail') },
                { value: 3, label: __('3 days', 'classdetail') },
                { value: 4, label: __('4 days', 'classdetail') },
                { value: 5, label: __('5 days', 'classdetail') },
                { value: 6, label: __('6 days', 'classdetail') },
              ]
            },
            shown: true,
          }
        }

        if (FREQUENCY[frequency] == 'weekly') {
          required = ['every', 'which_day_str'].concat(required);
          every = {
            ...every,
            'ui:options': {
              selectOptions: [
                { value: 1, label: __('1 week', 'classdetail') },
                { value: 2, label: __('2 weeks', 'classdetail') },
                { value: 3, label: __('3 weeks', 'classdetail') },
                { value: 4, label: __('4 weeks', 'classdetail') },
                { value: 5, label: __('5 weeks', 'classdetail') },
                { value: 6, label: __('6 weeks', 'classdetail') },
              ]
            },
            shown: true,
          }

          which_day_str = {
            ...which_day_str,
            'ui:widget': 'selectDaysInWeek',
            shown: true,
          }
        }

        if (FREQUENCY[frequency] == 'monthly') {
          required = ['which_day_str'].concat(required);
          which_day_str = {
            ...which_day_str,
            'ui:widget': 'selectDaysInMonth',
            shown: true,
          }
        }

      }
    } // if (mode==='CREATE')


    //
    // STEP 3. Get required and REMOVE data that's not used
    //
    if (uiLogic.scheduling) {
      processedFormData.frequency = processedFormData.frequency || 0;
      processedFormData.every = processedFormData.every || 1;
      processedFormData.which_day = processedFormData.which_day || [];
    }

    if (uiLogic.classType == 'multi') {
      required = required.concat([
        //
        // NOTE: student and teacher are not required to input
        // 'student_id_list_str',
        // 'teacher_id_list_str',
        //
      ]);
    } else if (uiLogic.classType == '1on1') {
      //
      // STEP 3-1. if classtype is '1on1'
      //
      // processedFormData.student_id_list = classDetail.getStudentIdList(); // because student cannot be modified we use the ids from classDetail
      // NOTE: removed because now we allow adding extra students to private class
    }

    if (mode === CREATE) {
      required = [
        'date_range_str',
        'time_range_str',
        // 'classroom_id_str', // <--
      ].concat(required);

    } else if (mode === UPDATE) {
      required = [
        'lesson_date',
        'time_range_str',
        // 'classroom_id_str', // <--
      ].concat(required);
    }

    let updateSpecificFields;
    let createSpecificFields;

    if (mode === CREATE) {
      createSpecificFields = {
        date_range_str: {
          title: __('Date', 'DateRange'),
          type: 'string',
        },
        frequency: {
          title: __('Frequency', 'classdetail'),
          type: 'number',

        },
        every: {
          type: 'number',
          title: __('Every', 'classdetail'),
        },
        which_day_str: {
          type: 'string',
          title: __('Select', 'classdetail'),
        },
      }
    }
    if (mode === UPDATE) {
      updateSpecificFields = {
        lesson_date: {
          type: 'string',
          title: __('Date', 'DateRange'),
        }
      }
    }

    //
    // STEP 4. Set Schema. note that we're passing studentList as itemList
    //
    this.schema = {
      type: 'object',
      required,
      properties: {

        ...updateSpecificFields,
        ...createSpecificFields,

        teacher_id_list_str: {
          title: __('Teachers', 'class'),
          type: 'string',
          itemList: classDetail.teacherList, // to be used in SelectClassTeacher modal
          mixin: (item)=>{
            return item;
          }
        },
        student_id_list_str: {
          title: __('Students', 'class'),
          type: 'string',
        },
        classroom_id_str: {
          title: __('Classroom', 'classdetail'),
          type: 'string',
        },
        time_range_str: {
          title: __('Time', 'TimeRange'),
          type: 'string',
        },
        calendar_color: {
          title: __('Lesson Color', 'schedule'),
          type: 'string',
        },
        scheduling: {
          title: __('Batch Scheduling', 'classdetail'),
          type: 'boolean',
        },
        note: {
          title: __('Note', 'EditLessonForm'),
          type: 'string',
        },
      }
    }

    //
    // STEP 5. return UI Schema
    //
    this.uiSchema = {
      items: {
        lesson_date: {
          'ui:widget': 'datepicker',
          shown: mode === UPDATE,
        },
        date_range_str: {
          'ui:widget': 'daterange',
          'ui:options': {
            orientation: "vertical",
            verticalHeight: 568,
            minimumNights: 0, // THIS allow selecting a same date
          },
          shown: mode === CREATE,
          afterContent: uiLogic.sameDate === true ? <div className='same-dates-message'><i className='fa icon-calendar'/> {__('Same date will only create single lesson', 'schedule')}</div> : '',
        },

        time_range_str: {
          className: 'col-sm-12',
          'ui:widget': 'timerange',
          'ui:options': {
            'minuteStep': 5,
          }
        },

        frequency: {
          'ui:widget': 'dropdownselect',
          'ui:options': {
            selectOptions: [
              { value: FREQUENCY.indexOf('daily'), label: __('By Day', 'classdetail') },
              { value: FREQUENCY.indexOf('weekly'), label: __('By Week', 'classdetail') },
              { value: FREQUENCY.indexOf('monthly'), label: __('By Month', 'classdetail') },
            ]
          },
          shown: uiLogic.scheduling === true,
          inline: true,
        },

        every,

        which_day_str,

        classroom_id_str: {
          className: 'col-sm-12',
          'ui:widget': 'selectClassroom',
          'ui:options': {
            conflictedIDs: conflictedSummary.conflicted_classroom_result === true ? [classroom_id] : [],
          },
          shown: true,
          afterContent: conflictedSummary.conflicted_classroom_result === true ? <div className='error-message'>{__('The classroom is in use during this period.', 'classdetail')}</div> : <div />
        },

        teacher_id_list_str: {
          className: 'col-sm-12',
          'ui:widget': 'selectClassTeacher',
          'ui:options': {
            selectMultiple: true,
            conflictedIDs: conflictedSummary.conflicted_teacher_summary,
          },
          shown: true,
          afterContent: conflictedSummary.conflicted_teacher_summary.length > 0 ? <div className='error-message'>{__('One or more teachers are occupied during this period.', 'classdetail')}</div> : <div/>,
        },

        student_id_list_str: {
          className: 'col-sm-12',
          'ui:widget': 'selectClassStudent',
          'ui:options': {
            selectMultiple: true,
            // selectMultiple: type == 0 ? true : false,
            conflictedIDs: conflictedSummary.conflicted_student_summary,
            // disableSelect: uiLogic.disableSelectingStudent, // NOTE: as per FDT's request, we removed the restriction
          },
          shown: true,
          afterContent: conflictedSummary.conflicted_student_summary.length > 0 ? <div className='error-message'>{__('One or more students are occupied during this period.', 'classdetail')}</div> : <div/>,
        },

        note: {
          className: 'col-sm-12',
          'ui:widget': 'textarea',
          shown: true,
          'ui:options': {
            maxlength: 255,
          },
        },

        calendar_color: {
          className: 'col-sm-12',
          'ui:widget': 'colorpicker',
          'ui:options': {
            width: '100%',
          },
          shown: true,
        }

      }
    }

    return processedFormData;

  }

  render() {
    const {classDetail, lesson = {}} = this.props;
    const {formData, mode, loading} = this.state;

    return (
      <div className={classnames('add-lesson-form')} data-dev-note='LOCATED in template/Forms/EditLesson.js' ref={(f)=>{this.lessonFormRef=f;}}>
        <div className='content'>
          { mode === CREATE && <h5>{__('Add New Lesson', locale)}</h5> }
          <h3 className='add-lesson-class-name'>{lesson.title || classDetail.name}</h3>
          <Form
            fetching={loading}
            formData={formData}
            onSubmit={this.onSubmit}
            onError={this.onError}
            schema={this.schema}
            uiSchema={this.uiSchema}
            onChange={this.processFormData}
            getSubmitButton={(s)=>{ this.submit = s; }}>
            <div className='button-section'>
              <Button type='submit' bsStyle='primary'>{__('Save', 'teacher')}</Button>
              { mode === UPDATE &&
                 <Button bsStyle='link' className='danger' onClick={this.deleteLesson}>{__('Delete Lesson', 'classdetail')}</Button>
              }
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default EditLesson;



// WEBPACK FOOTER //
// ./src/template/Forms/EditLesson/index.js